function dismissToast(toast) {
  if (toast.classList.contains('is-leaving')) return
  toast.classList.add('is-leaving')
  window.setTimeout(() => toast.remove(), 200)
}

function initializeFlashToasts() {
  document.querySelectorAll('[data-flash-toast]').forEach(toast => {
    if (toast.dataset.initialized) return
    toast.dataset.initialized = 'true'

    const timeout = window.setTimeout(() => dismissToast(toast), 4000)
    const close = toast.querySelector('.flash-toast-close')
    if (close) close.addEventListener('click', () => {
      window.clearTimeout(timeout)
      dismissToast(toast)
    })
  })
}

document.addEventListener('DOMContentLoaded', initializeFlashToasts)
document.addEventListener('turbolinks:load', initializeFlashToasts)
document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('[data-flash-toast]').forEach(toast => toast.remove())
})
if (document.readyState !== 'loading') initializeFlashToasts()
